import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useGetTagTypesQuery, useGetTagListWithTypeQuery } from '../../../generated/graphql';
import { FormAutoComplete, FormCheckbox } from '../../form';
import { FilterTag } from '../../../App.enums';
import styles from './AddFilterDialog.module.css';

type AddFilterDialogProps = {
    onClose: (tag?: FilterTag) => void,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const AddFilterDialog = (props: AddFilterDialogProps) => {
    const { style, visible, onClose } = props;
    const [tagType, setTagType] = useState('');
    const [searchTag, setSearchTag] = useState('');
    const [inverse, setInverse] = useState(false);
    const [validationError, setValidationError] = useState('');
    const types = useGetTagTypesQuery({ fetchPolicy: "no-cache" });
    const tags = useGetTagListWithTypeQuery({
        variables: { contains: searchTag, type: tagType }
    });

    const handleSubmit = () => {
        const selectedType = types.data?.TagTypes?.filter(l => l === tagType)[0];
        const selectedTag = tags.data?.TagList?.nodes?.filter(t => t?.name === searchTag)[0];

        if (!tagType || !searchTag) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        if (!selectedType) {
            setValidationError('Please Select A Valid Type!');
            return;
        }
        if (!selectedTag) {
            setValidationError('Please Select A Valid Tag!');
            return;
        }
        setValidationError('');
        const tag = tags.data?.TagList?.nodes?.filter(l => l?.name === searchTag).map(t => t as FilterTag);
        tag && onClose({ ...tag[0], inverse });
    };

    return (
        <DialogBase
            title="Add Filter"
            type="OkCancel"
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            className={styles.AddFilterDialog}
            style={style}
            data-testid="AddFilterDialog">
            <FormAutoComplete
                label="Tag Type"
                name="type"
                value={tagType}
                onChange={setTagType}
                options={(types.data?.TagTypes || []).filter((t): t is string => !!t)}
            />
            <FormAutoComplete
                label="Tag"
                name="tag"
                value={searchTag}
                onChange={setSearchTag}
                options={(tags.data?.TagList?.nodes?.map(p => p?.name) || []).filter((n): n is string => !!n)}
            />
            <FormCheckbox
                label="Inverse filter (exclude items with this tag)"
                name="inverse"
                checked={inverse}
                onChange={setInverse}
            />
        </DialogBase>
    );
};

export default AddFilterDialog;